import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Initiatives from "./pages/Initiatives";
import Impact from "./pages/Impact";
import Partnership from "./pages/Partnership";
import Team from "./pages/Team";
import News from "./pages/News";
import { CMSProvider } from "./context/CMSContext";
import Admin from "./pages/admin/Admin";

function App() {
  return (
    <CMSProvider>
      <Router>
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/initiatives" element={<Initiatives />} />
                <Route path="/impact" element={<Impact />} />
                <Route path="/partnership" element={<Partnership />} />
                <Route path="/team" element={<Team />} />
                <Route path="/news" element={<News />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </CMSProvider>
  );
}

export default App;
